import { ADD_CHARACTERS , DEL_CHARACTERS} from '../actions/action-types'

localStorage.getItem('characters') === null && localStorage.setItem('characters', JSON.stringify([]))
const defaultState = { charactersHome : JSON.parse(localStorage.getItem('characters')) }

const reducer = (state = defaultState, action) => {
  
  switch (action.type) {
    case ADD_CHARACTERS:
      return {
        ...state,
        charactersHome : [...state.charactersHome, action.newCharacter]
      }

    case DEL_CHARACTERS:
      return {
        ...state,
        charactersHome: state.charactersHome.filter(character => character.name !== action.newCharacter.name)
      }
    default:
      return state;

  }
}

export default reducer